import { useEffect } from "react";
import AppStore from "./components/AppStore";
import ConnectSection from "./components/ConnectSection";
import HeroSection from "./components/HeroSection";
import JourneySection from "./components/JourneySection";
import { useLocation } from "react-router-dom";
import { storeToken } from "utils/storage";

function LandingScreen() {
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const refValue = searchParams.get("ref");
    if (refValue) {
      storeToken("referral", refValue);
    }
  }, [location]);

  return (
    <div className="landing-wrapper">
      <HeroSection />
      <ConnectSection />
      <JourneySection />
      <AppStore />
    </div>
  );
}

export default LandingScreen;
